<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.9018 8.29093L14.8556 2.52393C14.8506 2.51782 14.8447 2.51172 14.8397 2.50581C14.7806 2.44136 14.7125 2.38902 14.6404 2.34878C14.5263 2.28583 14.3952 2.25 14.2561 2.25H8.41626C5.87514 2.25 3.81445 4.31011 3.81445 6.85143V17.1505C3.81445 18.3708 4.29981 19.5412 5.16253 20.4041C6.02525 21.267 7.19624 21.7518 8.41626 21.7518C10.6181 21.7518 13.3784 21.7518 15.5803 21.7518C16.8003 21.7518 17.9702 21.267 18.8339 20.4041C19.6966 19.5412 20.1811 18.3708 20.1811 17.1505C20.1811 13.615 20.1811 8.89484 20.1811 8.89484C20.1811 8.65284 20.073 8.43625 19.9018 8.29093ZM15.7754 9.68709H18.5968V17.1505C18.5968 17.9506 18.2785 18.7179 17.713 19.2837C17.1475 19.8494 16.3799 20.1672 15.5803 20.1672C13.3784 20.1672 10.6181 20.1672 8.41626 20.1672C7.61659 20.1672 6.84893 19.8494 6.28346 19.2837C5.71699 18.7179 5.39976 17.9506 5.39976 17.1505V6.85143C5.39976 5.18534 6.74987 3.83472 8.41626 3.83472H13.4644C13.4644 4.74017 13.4644 6.24313 13.4644 7.37627C13.4644 8.65254 14.4984 9.68709 15.7754 9.68709ZM15.0488 5.15112V7.37627C15.0488 7.77741 15.3741 8.10247 15.7754 8.10247H17.631L15.0488 5.15112Z"
      fill="#141414"
    />
    <path
      d="M10.4761 17.5L8.30814 15.3314C7.99901 15.0224 7.99901 14.5205 8.30814 14.2113C8.61727 13.9023 9.11854 13.9023 9.42767 14.2113L11.0363 15.8199L14.5758 12.2804C14.8849 11.9713 15.3871 11.9713 15.6962 12.2804C16.0053 12.5895 16.0053 13.0914 15.6962 13.4004L11.5965 17.5C11.2874 17.8093 10.7852 17.8093 10.4761 17.5Z"
      fill="#141414"
    />
  </svg>
</template>

<script>
export default {
  name: 'FileUploaded'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
